import { getSearch } from '../window';

export type OptOutSource = 'connect-imported' | 'connect-synced';

const VALID_SOURCES: OptOutSource[] = ['connect-imported', 'connect-synced'];

export const getSource = (): OptOutSource | undefined => {
  try {
    const params = new URLSearchParams(getSearch().substring(1));
    const value = params.get('source') || undefined;
    if (value && VALID_SOURCES.includes(value as OptOutSource)) {
      return value as OptOutSource;
    }
    return undefined;
  } catch (e) {
    // IE fallback
    const match = getSearch().match(/source=(connect-imported|connect-synced)/)?.[1];
    return match as OptOutSource | undefined;
  }
};
